import { FlowGrid, H6, InfoSheet, Radio, RadioGroup, Row } from '@fs/zion-ui'
import React, { useState, useCallback, memo } from 'react'
import { useTranslation } from 'react-i18next'
import ListIcon from '../../images/List.svg'
import GroupIcon from '../../images/Group.svg'
import { useR2DispatchContext, useR2StateContext } from '../../../../providers/r2Provider/R2Context'

// Kind of enum for getting the posible values from the panel
export const VIEW_FORMAT = {
  group: 'group',
  list: 'list',
}

// Each of the otions shown in the panel
const RadioOption = memo(({ currentValue, value, label, onChange, imageSrc }) => (
  <Row alignY="middle">
    <Radio checked={currentValue === value} label={label} name="format" value={value} onChange={onChange} growX />
    <img src={imageSrc} height={45} alt={`${label} icon`} />
  </Row>
))

const PreferencesPanel = ({ overlayProps }) => {
  const dispatch = useR2DispatchContext()
  const { historyFormat } = useR2StateContext()
  const { t } = useTranslation()

  // State to track the selected value
  const [viewAs, setViewAs] = useState(historyFormat)

  // Handler to update the selected value and pass the value to parent component
  const handleChange = useCallback(
    ({ target: { value } }) => {
      setViewAs(value)
      dispatch({ type: 'SET_HISTORY_FORMAT', value })
    },
    [dispatch]
  )

  return (
    <InfoSheet size="md" title={t('history-viewer.preferences.button', 'Preferences')} {...overlayProps}>
      <FlowGrid gutters="xs" orientation="vertical" columnCount={1}>
        <H6>{t('history-viewer.preferences-panel.options.title', 'Format')}</H6>
        <RadioGroup orientation="vertical">
          <RadioOption
            currentValue={viewAs}
            value={VIEW_FORMAT.list}
            label={t('history-viewer.preferences-panel.options.as-list', 'Display as List')}
            imageSrc={ListIcon}
            onChange={handleChange}
          />
          <RadioOption
            currentValue={viewAs}
            value={VIEW_FORMAT.group}
            label={t('history-viewer.preferences-panel.options.as-group', 'Display as Group')}
            imageSrc={GroupIcon}
            onChange={handleChange}
          />
        </RadioGroup>
      </FlowGrid>
    </InfoSheet>
  )
}

export default PreferencesPanel
